// Build the `since=<local-midnight-with-offset>` query the API uses to anchor
// "today" reasoning. Mirrors src/Optimize.Web/Services/LocalDay.cs verbatim —
// the server reads the offset, so we must NOT convert to UTC before sending.
export function sinceQuery(): string {
  const now = new Date();
  const local = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  // Replicate DateTimeOffset.ToString("o"): yyyy-MM-ddTHH:mm:ss.fffffff±HH:mm
  const pad = (n: number, w = 2) => String(n).padStart(w, '0');
  const offsetMin = -local.getTimezoneOffset();
  const sign = offsetMin >= 0 ? '+' : '-';
  const absMin = Math.abs(offsetMin);
  const offset = `${sign}${pad(Math.floor(absMin / 60))}:${pad(absMin % 60)}`;
  const iso = `${local.getFullYear()}-${pad(local.getMonth() + 1)}-${pad(local.getDate())}T00:00:00.0000000${offset}`;
  return `since=${encodeURIComponent(iso)}`;
}
